import type { Feature, FeatureModule } from '../../../../types';
import { featureList } from '../../../helpers';
import { DEVELOPMENT_SETTINGS_FEATURE_GROUP } from './group';

export const DEVELOPMENT_SETTINGS_FEATURES = {
  ACCESS: {
    guid: 'c5cb33bf-2aa2-4c64-95da-9e569fcd0001',
    name: 'development:settings:access',
    description: 'Access the Development Settings tool',
    action: 'read',
    product: 'app',
    parentGuid: DEVELOPMENT_SETTINGS_FEATURE_GROUP.guid,
  },
} as const satisfies Record<string, Feature>;

export { DEVELOPMENT_SETTINGS_FEATURE_GROUP } from './group';

export const DEVELOPMENT_SETTINGS_MODULE: FeatureModule = {
  product: 'app',
  groups: [DEVELOPMENT_SETTINGS_FEATURE_GROUP],
  features: featureList(DEVELOPMENT_SETTINGS_FEATURES),
};
